import axios from "axios";
import Endpoints from "../Endpoints";

const authHeader = () => ({
    headers: { 'Authorization': `Bearer ${localStorage.getItem('USER_TOKEN')}` }
});

export const getUserBadges = async () => {
    const { data } = await axios.get(Endpoints.UserBadge.LIST, authHeader());
    return data.data;
};

export const createUserBadge = async (badgeData) => {
    const { data } = await axios.post(Endpoints.UserBadge.CREATE, badgeData, authHeader());
    return data.data;
};

export const updateUserBadge = async (id, badgeData) => {
    const { data } = await axios.put(Endpoints.UserBadge.UPDATE + id, badgeData, authHeader());
    return data.data;
};

export const deleteUserBadge = async (id) => {
    const { data } = await axios.delete(Endpoints.UserBadge.DELETE + id, authHeader());
    return data;
};
